import { Container } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Page from '../../../components/Page';
import StudentFeedDashboard from './StudentFeed';
import { getAllFeedsByOrg } from '../../../service/feed.service';
import { SET_ORG_FEEDS } from '../../../redux/constants';
import { SkeletonDashboardFeed } from '../../../fl-components/skeleton/SkeletonDashboardFeed';

export default function StudentInsights() {
  const feedList = useSelector((state) => state.feeds.orgFeeds);
  const [isLoading, setIsLoading] = useState(feedList === null);
  const selectedOrg = useSelector((state) => state.org.selectedOrg);
  const feedOffset = useSelector((state) => state.feeds.orgFeedOffset);
  const dispatch = useDispatch();

  useEffect(() => {
    async function fetchFeedList() {
      const res = await getAllFeedsByOrg(selectedOrg?.id ?? selectedOrg?.orgId, feedOffset);
      if (res) {
        dispatch({
          type: SET_ORG_FEEDS,
          payload: {
            feeds: res.results,
            offset: feedOffset + 1
          }
        });
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    }
    if ((selectedOrg?.id ?? selectedOrg?.orgId) && feedList === null) fetchFeedList();
    else setIsLoading(false);
  }, [selectedOrg]);

  return (
    <Page title="Dashboard">
      {isLoading ? (
        <SkeletonDashboardFeed />
      ) : (
        <Container>
          <StudentFeedDashboard />
        </Container>
      )}
    </Page>
  );
}
